import { render, staticRenderFns } from "./PanelAdminPeriodo.vue?vue&type=template&id=0dae5ffd&scoped=true"
import script from "./PanelAdminPeriodo.vue?vue&type=script&lang=js"
export * from "./PanelAdminPeriodo.vue?vue&type=script&lang=js"
import style0 from "./PanelAdminPeriodo.vue?vue&type=style&index=0&id=0dae5ffd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dae5ffd",
  null
  
)

export default component.exports